/* eslint-disable no-undef */

export default {
	name: "sales-rep-customer-modal",
	props: ["heading", "modalId", "showModal", "userId"],
	emits: ["saleRepCustomerManagementModalOkClicked"],
	data() {
		return {
			salesRepCustomers: [],
			unassignedCustomers: [],
			salesRepCustomersHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCustomerCode"
				},
				{
					text: "VAT Number",
					field: "TaxVatNumber"
				},
				{
					text: "Phone Number",
					field: "primaryTelephoneNumber"
				}
			],
			pagingUnassignedCustomersDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			pagingSalesRepCustomersDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			assignedFilterStateChanged: false,
			unassignedFilterStateChanged: false,
			assignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			unassignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			showConfirmationMessage: false
		};
	},
	methods: {
		getSalesRepCustomers(){
			let request = {
				userId: this.userId,
				pageNumber: this.pagingSalesRepCustomersDetails.pageNumber,
				pageSize: this.pagingSalesRepCustomersDetails.pageSize,
				searchQuery: this.assignedFilter.customerSearchQuery,
				isActive: this.assignedFilter.activeOrInactiveItems === 1
			};
			securityService.getCompaniesAssignedToSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.salesRepCustomers = successResponse.data.result;
						this.pagingSalesRepCustomersDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingSalesRepCustomersDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						this.assignedFilterStateChanged = false;
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompaniesUnassignedToSalesRep(){
			console.log("this.unassignedFilter.activeOrInactive", this.unassignedFilter.activeOrInactive);
			var request = {
				userId: this.userId,
				pageNumber: this.pagingUnassignedCustomersDetails.pageNumber,
				pageSize: this.pagingUnassignedCustomersDetails.pageSize,
				searchQuery: this.unassignedFilter.customerSearchQuery,
				isActive: this.unassignedFilter.activeOrInactiveItems === 1
			};
			securityService.getCompaniesUnassignedToSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.unassignedCustomers = successResponse.data.result;
						this.unassignedFilterStateChanged = false;
						this.pagingUnassignedCustomersDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingUnassignedCustomersDetails.totalPages = successResponse.data.pagingInfo.totalPages;
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomersNotAssignedToSalesReps(){
			securityService.getCompaniesUnassignedToSalesReps().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.unassignedCustomers = successResponse.data.result;
						this.unassignedFilterStateChanged = false;
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAssignedActiveInactiveFilterSelected(activeOrInactiveKey){
			this.assignedFilter.activeOrInactiveItems = activeOrInactiveKey;
			this.assignedFilterStateChanged = true;
		},
		onUnassignedActiveInactiveFilterSelected(activeOrInactiveKey){
			this.unassignedFilter.activeOrInactiveItems = activeOrInactiveKey;
			this.unassignedFilterStateChanged = true;
		},
		onFilterSearchAssignedCustomersClicked(){
			this.pagingSalesRepCustomersDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getSalesRepCustomers()
		},
		onFilterSearchUnassignedCustomersClicked(){
			this.pagingUnassignedCustomersDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			//TODO: pass filter values to api
			//this.getCustomersNotAssignedToSalesReps();
			this.getCompaniesUnassignedToSalesRep();
		},
		onAssignedPaging(pagingInfo){
			this.pagingSalesRepCustomersDetails.pageNumber = pagingInfo.pageNumber;
			this.getSalesRepCustomers();
		},
		onUnassignedPaging(pagingInfo){
			this.pagingUnassignedCustomersDetails.pageNumber = pagingInfo.pageNumber;
			this.getCompaniesUnassignedToSalesRep();
		},
		unassignCustomerFromSalesRep(companyId){
			this.newUnassignedCustomers.push(companyId);
			console.log("customerId", companyId);
			for(var i = 0; i < this.salesRepCustomers.length; i++){
				if(this.salesRepCustomers[i].companyId === companyId){
					this.unassignedCustomers.push(this.salesRepCustomers[i]);
					this.salesRepCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newAssignedCustomers.length; j++){
				if(this.newAssignedCustomers[j] === companyId){
					this.newAssignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		assignCustomerFromSalesRep(companyId){
			this.newAssignedCustomers.push(companyId);
			console.log("companyId", companyId);
			for(var i = 0; i < this.unassignedCustomers.length; i++){
				if(this.unassignedCustomers[i].companyId === companyId){
					this.salesRepCustomers.push(this.unassignedCustomers[i]);
					this.unassignedCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newUnassignedCustomers.length; j++){
				if(this.newUnassignedCustomers[j] === companyId){
					this.newUnassignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		clearMessageAlerts(){
			this.showConfirmationMessage = false;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$emit("saleRepCustomerManagementModalOkClicked", true);
		},
		onModalCloseClick() {
			this.showConfirmationMessage = false;
			this.$emit("saleRepCustomerManagementModalOkClicked", true);
		},
		onSaveClick(){
			this.showConfirmationMessage = true;
		},
		onModalSaveClick(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			var request = {
				companyIdsToAssign: this.newAssignedCustomers,
				companyIdsToUnassign: this.newUnassignedCustomers,
				userId: this.userId
			};
			securityService.assignAndUnassignCompaniesToSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.newAssignedCustomers = [];
						this.newUnassignedCustomers = [];
						this.showSuccessMessage = true;
						this.successMessage = "Sales Rep Assigned Customers Updated Successfully";
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = "Unexpected error occurred";
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		userId:{
			handler: function () {
				if(this.userId != null && this.userId > 0){
					this.getSalesRepCustomers();
					//this.getCustomersNotAssignedToSalesReps();
					this.getCompaniesUnassignedToSalesRep();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
